import React, { Component } from 'react';
import { connect } from 'react-redux';
import Text from '@bit/knotchinc.web-react-components.text';
import { SET_REPORT_REQUEST_KEY, submitReport } from 'components/Pages/Reports/actions.js';
import CompleteStep from './steps/CompleteStep.jsx';
import { RequestContainer, ProgressStep, ProgressLoading, ProgressBar, ButtonContainer, StepsContainer,
  ProgressStepsContainer, BackButton, NextButton } from './styled.js';

class ReportRequestManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      steps: props.children.map(child => ({
        isValid: false,
        name: child.type.WrappedComponent ? child.type.WrappedComponent.defaultProps.name : child.props.name,
        component: child.type.WrappedComponent ? child.type.WrappedComponent.name : child.type.name,
      })),
      complete: false,
      submitted: false,
    };
  }

  setValid(stepIndex, isValid) {
    const { steps } = this.state;
    const newSteps = [...steps];
    newSteps[stepIndex].isValid = isValid;
    this.setState({ steps: newSteps });
  }

  next() {
    const { currentStep, steps } = this.state;
    const nextStep = currentStep + 1;
    const isLast = nextStep === steps.length;
    const everythingValid = steps.reduce((isValid, step) => isValid && step.isValid, true);
    this.setState({ currentStep: isLast ? currentStep : nextStep, complete: everythingValid });
  }

  back() {
    const { currentStep } = this.state;
    const prevStep = currentStep - 1;
    this.setState({ currentStep: prevStep >= 0 ? prevStep : 0 });
  }

  render() {
    const { children, posting, posted } = this.props;
    const { steps, currentStep } = this.state;
    const currentValid = steps[currentStep].isValid;
    const isLast = currentStep + 1 === steps.length;
    const firstStep = currentStep === 0;
    const submitted = posting || posted;

    return (
      <RequestContainer>
        <StepsContainer height="80%" width="100%">
          {posted ?
            <CompleteStep /> :
           React.cloneElement(children[currentStep], {
             setValid: (isValid) => this.setValid(currentStep, isValid),
           })}
        </StepsContainer>
        <ButtonContainer>
          {!submitted && <BackButton
            isDisabled={firstStep}
            onClick={() => this.back()}
          >
            BACK
          </BackButton>}
          <ProgressStepsContainer>
            {submitted && <ProgressLoading />}
            {!submitted && steps.map(({ name, isValid }, i) =>
              <ProgressStep
                onClick={() => this.setState({ currentStep: i })}
                width={`${100 / (steps.length || 1)}%`}
                key={`progress_${i}_${name}`}
              >
                <ProgressBar isValid={isValid} />
                <Text>Step {i + 1}</Text>
                <Text fontSize="14px" color="#939AAB">{name}</Text>
              </ProgressStep>)}
          </ProgressStepsContainer>
          {(isLast && !posted) &&
            <NextButton
              isValid={currentValid}
              isDisabled={!currentValid}
              onClick={() => currentValid && this.props.submit()}
            >
              CREATE
          </NextButton>}
          {(!submitted && !isLast) &&
            <NextButton
              isValid={currentValid}
              isDisabled={!currentValid}
              onClick={() => currentValid && this.next()}
            >
              NEXT
            </NextButton>
          }
          {(posted) &&
            <NextButton
              isValid
              onClick={() => this.props.close()}
            >
            CLOSE
          </NextButton>}
        </ButtonContainer>
      </RequestContainer>
    );
  }
}

const mapStateToProps = ({
  ReportRequest: { posting, posted },
}) => ({ posting, posted });

function mapDispatchToProps(dispatch) {
  return {
    setPayload: (payload) => dispatch({ type: SET_REPORT_REQUEST_KEY, payload }),
    submit: () => dispatch(submitReport()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportRequestManager);
